import script from "./ModalAguardandoIA.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalAguardandoIA.vue?vue&type=script&setup=true&lang=js"

import "./ModalAguardandoIA.vue?vue&type=style&index=0&id=4e625b18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e625b18"]])

export default __exports__